import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { fillTabContentInNewDynamicScreenEpic } from './fillTabContentInNewDynamicScreenEpic';
import { fillTabContentInNewDynamicScreenFailedEpic } from './fillTabContentInNewDynamicScreenFailedEpic';
export const dynamicScreenTabContentEpic = () =>
  withAppCrashIfException(
    'dynamicScreenTabContent',
    combineEpics(
      fillTabContentInNewDynamicScreenEpic(), // no async, should be a thunk
      fillTabContentInNewDynamicScreenFailedEpic(), // no async, should be a thunk
    ),
  );
